import * as React from 'react'

import {
  type MediaDefaultsOptions,
  getMediaDefaultsFormValues,
  normalizeMediaDefaultsPayload,
  resolveAvatarUrl,
  resolveDefaultAvatarUrl,
  resolveDefaultFaviconUrl,
  resolveDefaultThumbnailUrl,
  resolveThumbnailUrl,
} from '@/lib/tenant-media-defaults'
import { useBrandingHostname } from '@/hooks/use-branding'
import { useTenantConfig } from '@/hooks/use-tenant-config'

import { isFsdsHostname } from '@/utils/domain-branding-resolver'

export function useTenantMediaDefaults() {
  const { customization, refreshConfig } = useTenantConfig()
  const hostname = useBrandingHostname()
  const isFsdsDomain = React.useMemo(() => {
    if (hostname) {
      return isFsdsHostname(hostname)
    }
    return null
  }, [hostname])

  const options = React.useMemo<MediaDefaultsOptions>(
    () => ({
      isFsdsDomain: isFsdsDomain === null ? undefined : isFsdsDomain,
    }),
    [isFsdsDomain]
  )

  return {
    customization,
    refreshConfig,
    isFsdsDomain,
    defaultAvatarUrl: resolveDefaultAvatarUrl(customization, options),
    defaultThumbnailUrl: resolveDefaultThumbnailUrl(customization, options),
    defaultFaviconUrl: resolveDefaultFaviconUrl(customization),
    resolveAvatarUrl: (avatar?: string | null) => resolveAvatarUrl(avatar, customization, options),
    resolveThumbnailUrl: (thumbnail?: string | null) => resolveThumbnailUrl(thumbnail, customization, options),
    formValues: getMediaDefaultsFormValues(customization),
    normalizePayload: normalizeMediaDefaultsPayload,
  }
}
